module.exports = __webpack_public_path__ + "img/05.f3e1d057.png";